import { Color } from "./server/enums/color.enum";

export const colors = {
  solid: {
    primary: Color.BLUE,
    secondary: Color.RED,
    success: "#198754",
    info: "#0dcaf0",
    warning: "#ffc107",
    danger: Color.RED,
    dark: "#212529",
    black: "#000",
    white: Color.WHITE,
    body: "#f8f9fa",
  },
  light: {
    primary: "#0060A91a",
    secondary: Color.RED,
    success: "#1987541a",
    info: "#0dcaf01a",
    warning: "#ffc1071a",
    danger: Color.RED,
    dark: "#2125291a",
  },
};
